import { Component, Injectable, Input, Output, EventEmitter } from "@angular/core";
import { NGXLogger } from "ngx-logger";

@Injectable()
export class InfoService {
    header:string;
    message:string;
    @Output() fire: EventEmitter<any> = new EventEmitter();

    constructor(private logger: NGXLogger) {
        this.logger.debug("gen info service calling...")
    }
}


// WEBPACK FOOTER //
// ./src/app/info/info-service.ts